import {
  INVOICE_DATA_ALL_RECORDS_REQUEST,
  INVOICE_DATA_ALL_RECORDS_SUCCESS,
  INVOICE_DATA_ALL_RECORDS_FAIL,
  INVOICE_DATA_CREATE_REQUEST,
  INVOICE_DATA_CREATE_SUCCESS,
  INVOICE_DATA_CREATE_FAIL,
  INVOICE_DATA_CREATE_RESET,
  INVOICE_DATA_UPDATE_REQUEST,
  INVOICE_DATA_UPDATE_SUCCESS,
  INVOICE_DATA_UPDATE_FAIL,
  INVOICE_DATA_UPDATE_RESET,
  INVOICE_DATA_DELETE_REQUEST,
  INVOICE_DATA_DELETE_SUCCESS,
  INVOICE_DATA_DELETE_FAIL,
  INVOICE_DATA_DELETE_RESET,
} from '../constants/invoiceDataConstants';

export const invoiceDataAllRecordsReducer = (state = { records: [] }, action) => {
  switch (action.type) {
    case INVOICE_DATA_ALL_RECORDS_REQUEST:
      return { loading: true, records: [] };
    case INVOICE_DATA_ALL_RECORDS_SUCCESS:
      return { loading: false, records: action.payload };
    case INVOICE_DATA_ALL_RECORDS_FAIL:
      return { loading: false, error: action.payload, records: [] };
    default:
      return state;
  }
};

export const invoiceDataCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_DATA_CREATE_REQUEST:
      return { loading: true };
    case INVOICE_DATA_CREATE_SUCCESS:
      return { loading: false, success: true, record: action.payload };
    case INVOICE_DATA_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case INVOICE_DATA_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const invoiceDataUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_DATA_UPDATE_REQUEST:
      return { loading: true };
    case INVOICE_DATA_UPDATE_SUCCESS:
      return { loading: false, success: true, record: action.payload };
    case INVOICE_DATA_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case INVOICE_DATA_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const invoiceDataDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_DATA_DELETE_REQUEST:
      return { loading: true };
    case INVOICE_DATA_DELETE_SUCCESS:
      return { loading: false, success: true };
    case INVOICE_DATA_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case INVOICE_DATA_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
